import { CSSObject } from '@chakra-ui/react';

export const ButtonSaveChanges: CSSObject = {};
